import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export const settingApi = {
  getSetting: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetSetting`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  getDraftSetting: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetDraftSetting`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
